/* eslint-disable no-prototype-builtins */
import React from 'react';
import { Col, Row } from 'react-styled-flexboxgrid';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AuthReducer, FreeProductsReducer } from '../../../interfaces';
import Styled from './Checkout.style';
import {
  Typography,
  Input,
  Select,
  Checkbox,
  Icon,
  Button,
  Wrap,
} from '../../../components';
import * as _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import OverlayLoader from '../../../components/OverlayLoader';
import LinkHandler from '../../../components/LinkHandler';
import { scrollToTop, getVariable } from '../../../helpers/helpers';
import { useTranslation } from 'react-i18next';
import { useResponsivity } from '../../../helpers/helpers';
import store from 'store2';

const titleOptions = [
  {
    value: 'mr',
    label: 'Mr',
  },
  {
    value: 'mrs',
    label: 'Mrs',
  },
  {
    value: 'miss',
    label: 'Miss',
  },
  {
    value: 'ms',
    label: 'Ms',
  },
  {
    value: 'dr',
    label: 'Dr',
  },
  {
    value: 'none',
    label: 'No title',
  },
  {
    value: 'other',
    label: 'Other',
  },
];

export interface CheckoutProps {
  page: FreeProductsReducer;
  preCheckout: Function;
  clearAddress: Function;
  persistDetails: Function;
  submitOrder: Function;
  submitOrderPack: Function;
  listLocation: any;
  getFreeProducts: Function;
  addToOrder: Function;
  removeFromOrder: Function;
  app: any;
  user: AuthReducer;
  userData: any;
}
const Checkout: React.FC<CheckoutProps> = (props) => {
  const {
    persistDetails,
    preCheckout,
    page,
    clearAddress,
    submitOrder,
    user,
    listLocation,
    app,
    userData,
    submitOrderPack,
  } = props;
  const { basket } = page;
  const isMobile = useResponsivity();
  const navigate = useNavigate();

  const wholesalerSlug = _.get(userData, 'data.data.wholesaler_slug');
  const organisationName = _.get(userData, 'data.data.property_name');

  const { loading: preCheckoutLoading } = page.preCheckout.status;
  const swsmInternal = getVariable('mode', 'swsm', false);
  const [t] = useTranslation('common');
  const title = t('portal.free_products.checkout.title');
  const fullAddress = t('portal.free_products.checkout.full_address');
  const yourAddress = t('portal.free_products.checkout.your_address');
  const postcodeText = t('portal.free_products.checkout.postcode');
  const selectAddress = t('portal.free_products.checkout.select_address');
  const disclaimer1 = t('portal.free_products.checkout.disclaimer1');
  const disclaimer2 = t('portal.free_products.checkout.disclaimer2');
  const disclaimer3 = t('portal.free_products.checkout.disclaimer3');
  const disclaimer4 = t('portal.free_products.checkout.disclaimer4');
  const disclaimer5 = t('portal.free_products.checkout.disclaimer5');

  const inputTitle = t('portal.free_products.checkout.input_title');
  const inputFirstname = t('portal.free_products.checkout.input_firstname');
  const inputLastname = t('portal.free_products.checkout.input_lastname');
  const inputEmail = t('portal.free_products.checkout.input_email');
  const inputPhone = t('portal.free_products.checkout.input_phone');
  const iAgree1 = t('portal.free_products.checkout.i_agree1');
  const iAgree2 = t('portal.free_products.checkout.i_agree2');
  const iAgree3 = t('portal.free_products.checkout.i_agree3');
  const iAgree4 = t('portal.free_products.checkout.i_agree4');
  const yourProducts = t('portal.free_products.checkout.your_products');

  const errorFirstname = t('portal.free_products.checkout.error_firstname');
  const errorLastname = t('portal.free_products.checkout.error_lastname');
  const errorAddress = t('portal.free_products.checkout.error_address');
  const errorPhone = t('portal.free_products.checkout.error_phone');
  const dataLocation = _.get(listLocation, 'data.data');

  const storedPropertyId = Number(store.get('property')) || 0;

  const findLocation = _.find(dataLocation, (o) => {
    return Number(o.id) === storedPropertyId;
  });

  const propertyId = findLocation?.id || storedPropertyId;

  const postcode = findLocation?.postcode;

  const udprn = _.get(app, 'userData.data.udprn');

  const selectAddressId: any = _.find(props.page.addresses.data, [
    'udprn',
    parseInt(udprn, 10),
  ]);
  const displayname = _.get(selectAddressId, 'displayname');
  const town = _.get(selectAddressId, 'town');
  const OrderSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, t('portal.general_form_errors.too_short') ?? undefined)
      .max(50, t('portal.general_form_errors.too_long') ?? undefined)
      .required(t('portal.general_form_errors.required') ?? undefined),
    spid: Yup.string().matches(/^\d{10}[SW]\d[\dX]$/, 'SPID is not valid'),
    lastName: Yup.string()
      .min(2, t('portal.general_form_errors.too_short') ?? undefined)
      .max(50, t('portal.general_form_errors.too_long') ?? undefined)
      .required(t('portal.general_form_errors.required') ?? undefined),
    email: Yup.string()
      .email(t('portal.general_form_errors.email_required') ?? undefined)
      .required(t('portal.general_form_errors.required') ?? undefined),
    toc: Yup.boolean().oneOf(
      [true],
      t('portal.general_form_errors.accept_terms') ?? undefined,
    ),
    phone: Yup.string()
      .required()
      .matches(
        /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/,
        'Mobile number is not valid',
      ),
    address: Yup.string().when([], {
      is: () => selectAddressId && !selectAddressId.displayname,
      then: Yup.string().required(
        t('portal.general_form_errors.required') ?? undefined,
      ),
      otherwise: Yup.string(),
    }),
  });

  const renderUrls = (url) => {
    const env = getVariable('mode', 'env');
    if (env === 'dev') {
      return `https://dev.business.getwaterfit.co.uk/#/${url}`;
    } else if (env === 'stage') {
      return `https://stage.business.getwaterfit.co.uk/#/${url}`;
    }
    return `https://business.getwaterfit.co.uk/#/${url}`;
  };

  React.useEffect(() => {
    if (swsmInternal) {
      scrollToTop();
    }
  }, [swsmInternal]);

  if (!user.data) {
    return null;
  }
  // if (_.isEmpty(basket)) {
  //   navigate('/free-products');
  // }

  const renderSummary = () => {
    if (!props.page.products.data) {
      return null;
    }

    const user = page.preCheckout;
    const products = props.page.products.data.products;

    if (products && basket) {
      return Object.keys(basket).map((productID, index) => {
        const product = products.find((item) => item.id === Number(productID));

        if (!product) {
          return null;
        }

        const productCreditAudit = _.get(user, `creditAudit.${productID}`);

        const disabled =
          productCreditAudit && productCreditAudit.allowedQuantity === 0;

        const allowedQuantity = _.get(productCreditAudit, 'allowedQuantity');

        const errorMessage = _.get(productCreditAudit, 'message');

        const hasImage = _.get(product, 'images.path');

        const image = `https://cdn.savewatersavemoney.co.uk/cache/product_page${hasImage}`;

        return disabled ? (
          <Styled.ListWrap
            key={index}
            style={{
              borderBottom: '1px solid #e6e6e6',
              marginBottom: '16px',
            }}
          >
            <Styled.List id={`item-${productID}`}>
              <img width="60px" height="auto" src={image} alt={product.title} />

              <Styled.TextGroup>
                <Styled.ListQuantity data-test="quantity">
                  {allowedQuantity !== undefined
                    ? allowedQuantity
                    : basket[productID].total}
                  x
                </Styled.ListQuantity>

                <Styled.ListText data-test="name" disabled={disabled}>
                  {product.title}
                </Styled.ListText>
              </Styled.TextGroup>
            </Styled.List>

            <div>
              {errorMessage && (
                <Styled.ErrorMessage data-test="error">
                  {errorMessage}
                </Styled.ErrorMessage>
              )}
            </div>
          </Styled.ListWrap>
        ) : (
          <Styled.ListWrap key={index}>
            <Styled.List id={`item-${productID}`}>
              <img width="60px" height="auto" src={image} alt={product.title} />

              <Styled.TextGroup>
                <Styled.ListQuantity data-test="quantity">
                  {basket[productID].total}x
                </Styled.ListQuantity>

                <Styled.ListText data-test="name">
                  {product.title}
                </Styled.ListText>
              </Styled.TextGroup>
            </Styled.List>
          </Styled.ListWrap>
        );
      });
    }

    return null;
  };

  const addressOptions: any = () => {
    const addressList = _.map(props.page.addresses.data, (el: any) => {
      return {
        value: el.id,
        label: el.displayname,
      };
    });

    if (addressList.length === 0) {
      return [];
    }
    return addressList;
  };

  return (
    <Wrap>
      <Row>
        <Col xs={12} sm={12} md={12}>
          <Typography weight={700} size="1" text={title} />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Formik
            initialValues={{
              ...page.details,
            }}
            validationSchema={OrderSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              const { creditAudit } = page.preCheckout;

              const orderBasket = _.compact(
                _.map(basket, (element: { total: number }, id) => {
                  if (creditAudit && creditAudit.hasOwnProperty(id)) {
                    if (creditAudit[id].allowedQuantity === 0) {
                      return;
                    }
                    if (creditAudit[id].allowedQuantity > 0) {
                      return {
                        id,
                        quantity: creditAudit[id].allowedQuantity,
                      };
                    }
                  }
                  return {
                    id,
                    quantity: element.total,
                  };
                }),
              );

              const selectedAddress: any = _.find(props.page.addresses.data, [
                'id',
                parseInt(values.address, 10),
              ]);

              const orderData = {
                products: orderBasket,
                ...values,
                title: values.title === '' ? `${' '}` : values.title,
                uid: user.data?.id,
                postcode,
                address: selectAddressId
                  ? selectAddressId.id
                  : parseInt(values.address, 10),
                udprn: selectedAddress ? selectedAddress.udprn : udprn,
                spid: values.spid,
                waterClientSlug: wholesalerSlug,
              };

              submitOrderPack(
                orderData,
                propertyId,
                () => {
                  setSubmitting(false);
                  navigate('/free-products/thankyou');
                  clearAddress();
                },
                () => {
                  setSubmitting(false);
                },
              );
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => {
              const generateFullAddress = () => {
                if (page.addresses.data === null || values.address === '') {
                  return;
                }
                const selectedAddress: any = _.find(page.addresses.data, [
                  'id',
                  parseInt(values.address, 10),
                ]);

                return (
                  <React.Fragment>
                    <Styled.FullAddress>
                      <span style={{ color: '#25b3eb' }}>{fullAddress}:</span>{' '}
                      {selectedAddress.displayname}, {selectedAddress.town}
                    </Styled.FullAddress>
                  </React.Fragment>
                );
              };

              const renderSubmissionError = (errors) => {
                if (!errors) {
                  return null;
                }
                return (
                  <ul style={{ listStyleType: 'none' }}>
                    {_.map(errors, (el, index) => (
                      <li key={index}>{el}</li>
                    ))}
                  </ul>
                );
              };

              const saveAndHandleChange = (e) => {
                handleChange(e);
                persistDetails({
                  ...values,
                  [e.target.name]:
                    e.target.type === 'checkbox'
                      ? e.target.checked
                      : e.target.value,
                });
              };
              const handleSelectAddress = (e) => {
                saveAndHandleChange(e);

                const orderBasket = _.map(
                  basket,
                  (element: { total: number }, id) => ({
                    id,
                    quantity: element.total,
                  }),
                );

                const selectedAddress: any = _.find(props.page.addresses.data, [
                  'id',
                  parseInt(e.target.value, 10),
                ]);

                preCheckout({
                  postcode,
                  address: parseInt(e.target.value, 10),
                  udrpn: selectedAddress.udprn,
                  products: [...orderBasket],
                });
              };
              return (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col xs={12} sm={6}>
                      <Styled.BoxWrap>
                        <Styled.SectionHeader>
                          {' '}
                          <Styled.SectionTitle>
                            {yourAddress}
                          </Styled.SectionTitle>
                        </Styled.SectionHeader>
                        <Styled.AddressBlock>
                          <Styled.Postcode>
                            {postcodeText}
                            <span>{postcode}</span>
                          </Styled.Postcode>
                        </Styled.AddressBlock>
                        {displayname && town ? (
                          <Row>
                            <Col md={12} xs={12} sm={12}>
                              {displayname}, {town}
                            </Col>
                          </Row>
                        ) : null}
                        {displayname ? null : (
                          <Row>
                            <Col xs={12} sm={8}>
                              <Select
                                onChange={handleSelectAddress}
                                onBlur={handleBlur}
                                value={values.address}
                                aria-label={selectAddress}
                                name="address"
                                data-test="select-address"
                                placeholder={selectAddress}
                                options={addressOptions()}
                                error={
                                  errors.address && touched.address
                                    ? errors.address
                                    : undefined
                                }
                              />
                            </Col>
                          </Row>
                        )}
                        {generateFullAddress()}
                        {displayname && town ? (
                          <Styled.Disclaimer>
                            {disclaimer4}{' '}
                            <LinkHandler path="/profile">
                              {disclaimer5}
                            </LinkHandler>
                            . {disclaimer3}
                          </Styled.Disclaimer>
                        ) : (
                          <Styled.Disclaimer>
                            {disclaimer1}{' '}
                            <LinkHandler path="/contact-us">
                              {disclaimer2}
                            </LinkHandler>
                            . {disclaimer3}
                          </Styled.Disclaimer>
                        )}
                        <OverlayLoader loading={preCheckoutLoading} />
                      </Styled.BoxWrap>
                      <Styled.BoxWrap>
                        <Styled.SectionHeader>
                          <Styled.SectionTitle>
                            Order details
                          </Styled.SectionTitle>
                        </Styled.SectionHeader>
                        <Styled.OrderOrganisation>
                          Your property name is:{' '}
                          <strong>{organisationName}</strong>
                        </Styled.OrderOrganisation>
                        <Row>
                          <Col xs={12}>
                            <Select
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.title}
                              aria-label={inputTitle}
                              data-test="select-title"
                              name="title"
                              placeholder={inputTitle}
                              options={titleOptions}
                              error={
                                errors.title && touched.title
                                  ? errors.title
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Input
                              type="text"
                              name="firstName"
                              id="firstName"
                              label={inputFirstname}
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.firstName}
                              error={
                                errors.firstName && touched.firstName
                                  ? errors.firstName
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Input
                              type="text"
                              name="lastName"
                              id="lastName"
                              label={inputLastname}
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.lastName}
                              error={
                                errors.lastName && touched.lastName
                                  ? errors.lastName
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Input
                              type="text"
                              name="spid"
                              id="spid"
                              label={'SPID'}
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.spid}
                              error={
                                errors.spid && touched.spid
                                  ? errors.spid
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Input
                              type="email"
                              name="email"
                              id="email"
                              label={inputEmail}
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.email}
                              error={
                                errors.email && touched.email
                                  ? errors.email
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12}>
                            <Input
                              type="text"
                              name="phone"
                              id="phone"
                              label={inputPhone}
                              onChange={saveAndHandleChange}
                              onBlur={handleBlur}
                              value={values.phone}
                              error={
                                errors.phone && touched.phone
                                  ? errors.phone
                                  : undefined
                              }
                            />
                          </Col>
                        </Row>

                        <Checkbox
                          boxSize={20}
                          id="toc"
                          name="toc"
                          type="checkbox"
                          value={values.toc}
                          checked={values.toc}
                          onChange={saveAndHandleChange}
                          error={
                            errors.toc && touched.toc ? errors.toc : undefined
                          }
                        >
                          {iAgree1}{' '}
                          <a
                            target="_blank"
                            aria-label="Check out our terms and conditions"
                            rel="noopener noreferrer"
                            href={renderUrls('terms-and-conditions')}
                            style={{ color: '#0b2641', fontWeight: 600 }}
                          >
                            {iAgree2}
                          </a>
                          ,{' '}
                          <a
                            target="_blank"
                            aria-label="Check out our privacy policy"
                            rel="noopener noreferrer"
                            href={renderUrls('privacy')}
                            style={{ color: '#0b2641', fontWeight: 600 }}
                          >
                            {iAgree4}
                          </a>{' '}
                          {iAgree3}{' '}
                          <a
                            target="_blank"
                            aria-label="Check out our privacy policy"
                            rel="noopener noreferrer"
                            href={renderUrls('other-policies')}
                            style={{ color: '#0b2641', fontWeight: 600 }}
                          >
                            Other policies
                          </a>
                          .
                        </Checkbox>
                      </Styled.BoxWrap>
                    </Col>
                    <Col xs={12} sm={6}>
                      <Styled.BoxWrap>
                        <Styled.SectionHeader>
                          <Styled.SectionTitle>
                            {yourProducts}
                          </Styled.SectionTitle>
                        </Styled.SectionHeader>
                        <Styled.ProductList>
                          {renderSummary()}
                        </Styled.ProductList>

                        <OverlayLoader loading={preCheckoutLoading} />
                      </Styled.BoxWrap>
                    </Col>
                  </Row>

                  {page.order.status.error ? (
                    <Row>
                      <Col xs={12} sm={12}>
                        <Styled.BoxWrap>
                          <Styled.ErrorWrap>
                            <Icon icon="alert" size={100} />
                            {renderSubmissionError(page.order.status.error)}
                          </Styled.ErrorWrap>
                        </Styled.BoxWrap>
                      </Col>
                    </Row>
                  ) : null}

                  {errors.address ||
                  errors.firstName ||
                  errors.phone ||
                  errors.lastName ||
                  errors.toc ? (
                    <Row>
                      <Col xs={12} sm={12}>
                        <Styled.BoxWrap>
                          <Styled.ErrorWrap>
                            <Icon
                              icon="alert"
                              size={100}
                              style={{
                                marginRight: !isMobile ? '40px' : '0px',
                              }}
                            />
                            <Styled.ErrorList>
                              {errors.firstName ? (
                                <li>{errorFirstname}</li>
                              ) : null}
                              {errors.lastName ? (
                                <li>{errorLastname}</li>
                              ) : null}
                              {errors.phone ? <li>{errorPhone}</li> : null}
                              {errors.address ? <li>{errorAddress}</li> : null}
                              {errors.toc ? <li>{errors.toc}</li> : null}
                            </Styled.ErrorList>
                          </Styled.ErrorWrap>
                        </Styled.BoxWrap>
                      </Col>
                    </Row>
                  ) : null}
                  <Styled.CheckoutFooter>
                    <Styled.SubmitButton>
                      <Button
                        disabled={isSubmitting}
                        data-test="submit"
                        type="submit"
                      >
                        {t('portal.forgot_password.submit_button')}
                      </Button>
                    </Styled.SubmitButton>
                  </Styled.CheckoutFooter>
                </form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Wrap>
  );
};

export default Checkout;
